import ApplicationController from './application_controller';
import Intercom, {
  show,
  onUnreadCountChange
} from "@intercom/messenger-js-sdk";

export default class extends ApplicationController {
  static targets = [
    'count',
    'svg'
  ]
  
  static values = {
    settings: Object,
    showLauncher: Boolean,
    showCount: Boolean,
    shouldLoad: Boolean
  }

  initialize() {
    if (!this.shouldLoadValue) return;
    if (!this.settingsValue) return;

    Intercom(this.settingsValue);
  }

  connect() {
    if (this.showCountValue && this.hasCountTarget && this.hasSvgTarget) {
      const count = this.countTarget;
      const svg = this.svgTarget;
      
      onUnreadCountChange(function (unreadCount) {
        count.textContent = unreadCount > 99 ? '99' : unreadCount
        if (unreadCount === 0) {
          svg.style.display = 'block';
          count.style.display = 'none';
        } else {
          svg.style.display = 'none';
          count.style.display = 'inline-flex';
        }
      });
    }

    const params = new URLSearchParams(document.location.search);
    if (params.has('launch-intercom') || this.showLauncherValue) {
      this.launchMessenger();
    }
  }

  launchMessenger() {
    show();
  }
}